import { ReactNode } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, faInbox } from '@fortawesome/free-solid-svg-icons';

const Root = styled.div<{ $compact?: boolean }>`
  ${tw`flex flex-col items-center justify-center text-center w-full`}
  ${({ $compact }) => ($compact ? tw`px-4 py-8` : tw`px-6 py-14`)}
`;

const IconWrap = styled.div`
  ${tw`flex items-center justify-center w-12 h-12 mb-4 rounded-full`}
  background-color: var(--color-bg-secondary);
  color: var(--color-text-secondary);
`;

const Title = styled.h3`
  ${tw`text-base font-semibold`}
  color: var(--color-text-primary);
`;

const Description = styled.p`
  ${tw`mt-1 text-sm max-w-md`}
  color: var(--color-text-secondary);
`;

const Action = styled.div`
  ${tw`mt-5`}
`;

export function EmptyState({
  title,
  description,
  icon = faInbox,
  action,
  compact = false,
  className,
  'data-testid': testId,
}: {
  title: ReactNode;
  description?: ReactNode;
  icon?: IconDefinition | null;
  action?: ReactNode;
  compact?: boolean;
  className?: string;
  'data-testid'?: string;
}) {
  return (
    <Root $compact={compact} className={className} data-testid={testId}>
      {icon && (
        <IconWrap aria-hidden>
          <FontAwesomeIcon icon={icon} />
        </IconWrap>
      )}
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
      {action && <Action>{action}</Action>}
    </Root>
  );
}
